<template>
  <div class="regular-header">
  <navbar />

  <halfBanner>
    <template v-slot:intro-tekst>
      <h1>Loud Audiovisuals</h1>
      <p>Loud Audiovisuals is een opkomende VJ die middels oogverblindende 3D renders de festival ervaring in binnen- en buitenland naar een hoger niveau wil tillen. Wij zijn verantwoordelijk geweest voor het <a>product design</a> van Loud.</p>
      <a v-scroll-to="'#contact'">Read more!</a>
    </template>

    <template v-slot:intro-animation>
        <div class="intro-animation">
          <lottie :options="headerImages[0].defaultOptions"/>    
          <a> {{ headerImages[headerIndex].string }}  </a>
        </div>
    </template>

  </halfBanner>  

<div class="case-page">


   <titel>
    <template v-slot:intro-tekst>
      <h2>Online presence van Loud</h2>
      <p>Om het werk van Loud buiten de festivals ook zichtbaar te maken hebben wij een website ontwikkeld waarbij de visuals van Loud Audiovisuals de show stelen.</p>
    </template>
  </titel>

  <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid case odd">
      <div class="img-box">
        <img src="../../assets/cases/loudaudiovisuals/Folded_Paper_Werk_Loud_image_1.jpg">
      </div>
      <div class="text-box">
        <div class="content padding-left">
          <h3>Less is more</h3>
          <p>Om vooral niet af te leiden van alle toffe renders hebben wij gekozen voor een zwart-wit kleurenpalet zodat het werk wát er staat echt van je beeld knalt!</p>
        </div>
      </div>
    </div>
  </oddEvenGrid>

<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Framing the picture</h2>
    <p>Iedere render van Loud is een stukje kunst, het is dan ook niet gek dat wij elke case ook zo behandelen. Elk frame lijsten wij in zoals het een historisch kunstwerk dat niet zou misstaan in een museum.</p>

  </template>
  <template v-slot:case-img>
        <img src="../../assets/cases/loudaudiovisuals/Folded_Paper_Werk_Loud_image_3.jpg">
  </template>
</titelPictureBig>


<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Bouwblokken</h2>
    <p>Buiten het raamwerk dat we gecreërd hebben voor de diverse cases zijn er ook enkele elementen van Loud die zo gaaf zijn dat we ze speciale plekjes op de website hebben gegeven. Ze maken de website dynamischer. Deze zijn dus ook niet gebonden aan de kaders van de andere elementen. De vrijheid waar Loud voor staat.</p>
  </template>
  <template v-slot:case-img>
        <img src="../../assets/cases/loudaudiovisuals/Folded_Paper_Werk_Loud_image_4.jpg">
  </template>
</titelPictureBig>

<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Website</h2>
    <p>Om Loud’s werk het beste te vertellen kunnen we het beter gewoon laten zien. De intro van de website is dan ook een gave videoreel die bij binnenkomst van de website afspeelt. Deze intro zuigt je vanaf het begin af aan al in je beeldscherm zodat je er eigenlijk niet omheen kan om verder te scrollen!</p>
  </template>
  <template v-slot:case-img>
        <img src="../../assets/cases/loudaudiovisuals/Folded_Paper_Werk_Loud_image_5.jpg">
  </template>
</titelPictureBig>

<endCase v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
  <template v-slot:intro-tekst>
    <h2>Loud Audiovisuals samengevat</h2>
    <p>Een kleine case maar zeker niet minder leuk. Loud is aardig aan de weg aan het timmeren als een enthousiaste VJ die festivals naar een hoger niveau wilt tillen met zijn Visusals. Nationaal en internationaal komen er steeds meer boekingen bij. Samen zorgen wij ervoor dat wij zijn alsmaar groeiende portfolio en naamsbekendheid online up-to-date blijven houden. Keep your eyes out for this guy!</p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/Folded_Paper_Werk_Thanks.jpg">
  </template>
  <template v-slot:outro-tekst>
    <h4>Bekijk ook onze andere toffe cases</h4>
  </template>
</endCase>

  <caseGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
    <div class="row">
      <ul>
     <li>
          <router-link class="router-link" to="/werk/team-changing-academy">
            <div class="column tca">
              <img src="../../assets/Folded_Paper_case_thumbnail_Team_Changing_Academy.jpg">
              <span class="font-size-custom-max-12">Team Changing Academy / 2019 <br>Branding & product design</span>
            </div>
           </router-link>
        </li>

        <li>
          <router-link class="router-link" to="/werk/gowallet">
            <div class="column gowallet">
              <img src="../../assets/Folded_Paper_case_thumbnail_GoWallet.jpg">
              <span class="font-size-custom-max-12">Gowallet / 2018 <br>Branding & product design</span>
            </div>
          </router-link>
        </li>
    </ul>
  </div>
</caseGrid>

</div>

<footerComponent></footerComponent>

</div>

</template>

<script>
import navbar from '@/components/generalLayout/navbar.vue';
import halfBanner from '@/components/generalLayout/halfBanner.vue';
import caseGrid from '@/components/generalLayout/caseGrid.vue';
import titel from '@/components/generalLayout/werk/titel.vue';
import oddEvenGrid from '@/components/generalLayout/oddEvenGrid.vue';
import titelPictureMedium from '@/components/generalLayout/werk/titelPictureMedium.vue';
import titelPictureBig from '@/components/generalLayout/werk/titelPictureBig.vue';
import endCase from '@/components/generalLayout/werk/endCase.vue';
import fullWidthPicture from '@/components/generalLayout/werk/fullWidthPicture.vue';
import backgroundPattern from '@/components/generalLayout/werk/backgroundPattern.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';


import Lottie from '../../lottie.vue';
import * as animationLoudAudioVisuals from '@/assets/cases/loudaudiovisuals/headeranimatie/loudaudiovisuals.json';


export default {
    data () {
    return {
      headerImages: [
	      { defaultOptions: {animationData: animationLoudAudioVisuals.default}, string:'UX design / UI design / Development', },
      ],
    }
  },
  components:{
    navbar,
    halfBanner,
    titel,
    oddEvenGrid,
    titelPictureMedium,
    titelPictureBig,
    endCase,
    fullWidthPicture,
    backgroundPattern,
    caseGrid,
    footerComponent,
    'lottie': Lottie,
  },

  methods:{
    randomNumber(maxValue){
      return Math.floor(Math.random() * Math.floor(maxValue));
    }
  },
  computed:{
    headerIndex(){
      return this.randomNumber(this.headerImages.length);
    }
  },
}



</script>

<style lang="scss">

.home-bg-color{
  background: rgba(20,209,179,0.15) !important;
  background-repeat: no-repeat;
  background-size: cover;
}

.fold-container .first-content .intro-tekst{
  animation-delay: 1.4s;
}

.regular-header .fold-container .home-bg-color{
  animation-delay: .6s;
}

.regular-header .fold-container .case-hightlight-img .intro-animation{
  animation-delay: 1s;
}

body .case .img-box img, .odd-even-grid .text-box img{
  max-height: 600px !important;
  width: auto !important;
  margin:  auto;
  display: block;
}

.case-content{
  h2{
    padding-top: layout-val-64(0.5);
    padding-bottom: layout-val-8(1);
  }
}

.case-img-bg{
  background-color: #FFF8E7;
}

@media screen and (max-width: 960px) {
  body .case .img-box img, .odd-even-grid .text-box img{
    max-width: 400px !important;
  }
}

@media screen and (max-width: 830px) {
  body .case .img-box img, .odd-even-grid .text-box img{
    max-width: 300px !important;
  }
}

@media screen and (max-width: 720px) {
  .content-grid-two-rows{
    .firstenergy, .loud, .newschain, .tca{
      float: none;
    }
  }
}

@media screen and (max-width: 640px) {
  body .case .img-box img, .odd-even-grid .text-box img{
    max-width: 90% !important;
  }
  .home-bg-color{
    width: 100% !important;
    max-width: 100% !important;
    left:12px;
    border-right: 24px solid $white !important;
  }
}

</style>
